import React, { useEffect } from 'react';
import styled from 'styled-components';
import color from '../utils/style/color';
import locale from '../domain/locale';
import { useMountAndUnmount } from '../utils/hooks/lifeCycleHooks';
import env from '../utils/env';
import useScript from '../utils/hooks/useScript';
import { createUrl } from '../utils/url';
import { WA_SERVICE } from '../domain/waService';

const Wrapper = styled.div`
  border-radius: 2px;
  box-shadow: 0 1px 1px 0 rgba(221, 221, 221, 0.5);
  border: solid 1px ${color.gray.xxBright};
  padding: 6px;
  cursor: pointer;
`;

type Props = {
  isSignUp: boolean;
  onAppleLoginSuccess: (authCode: string) => void;
  onAppleLoginFailure: () => void;
};
interface AppleCustomEventDetail {
  authorization: {
    code: string;
  };
}

const AppleLoginButton = ({
  isSignUp,
  onAppleLoginSuccess,
  onAppleLoginFailure
}: Props) => {
  const scriptState = useScript(
    `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${locale.getLocaleWithRegion()}/appleid.auth.js`
  );

  const redirectUri = createUrl(WA_SERVICE.ACCOUNT, '/auth/apple-redirect');

  useEffect(() => {
    if (scriptState === 'ready') {
      AppleID.auth.init({
        clientId: env.appleLoginClientId.get(),
        redirectURI: redirectUri,
        scope: 'email',
        state: '',
        nonce: '',
        usePopup: true
      });
    }
  }, [scriptState]);
  const onAppleLoginSuccessWithEvent = ((
    data: CustomEvent<AppleCustomEventDetail>
  ) => {
    onAppleLoginSuccess(data.detail.authorization.code);
  }) as EventListener;

  useMountAndUnmount(
    () => {
      document.addEventListener(
        'AppleIDSignInOnSuccess',
        onAppleLoginSuccessWithEvent
      );
      document.addEventListener('AppleIDSignInOnFailure', onAppleLoginFailure);
    },
    () => {
      document.removeEventListener(
        'AppleIDSignInOnSuccess',
        onAppleLoginSuccessWithEvent
      );
      document.removeEventListener(
        'AppleIDSignInOnFailure',
        onAppleLoginFailure
      );
    }
  );

  return (
    <Wrapper>
      <div
        id="appleid-signin"
        data-color="white"
        data-border="false"
        data-type={isSignUp ? 'sign-up' : 'sign-in'}
        data-border-radius="2"
        style={{
          height: 36
        }}
      />
    </Wrapper>
  );
};

export default AppleLoginButton;
